export default "__VITE_ASSET__BL_BN7vN__"